import { render } from "./ListTeachers.vue?vue&type=template&id=baa82500&scoped=true"
import script from "./ListTeachers.vue?vue&type=script&lang=js"
export * from "./ListTeachers.vue?vue&type=script&lang=js"

import "./ListTeachers.vue?vue&type=style&index=0&id=baa82500&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baa82500"]])

export default __exports__